import { Link } from "react-router-dom";
import { Col, Row } from "reactstrap";
import { AllAbout, Href } from "../../../../constants";
import { SearchLinkLists } from "../../../../data/applications/SearchResult";
import PaginationCard from "./common/PaginationCard";

// This component displays video links in two equal columns with pagination.
const VideoTabs = () => {
  const midIndex = Math.ceil(SearchLinkLists.length / 2); // Calculate the midpoint index for splitting
  const firstColumnData = SearchLinkLists.slice(0, midIndex); // First half of the data
  const secondColumnData = SearchLinkLists.slice(midIndex); // Second half of the data

  return (
    <Row>
       {/* Map through the two column data arrays */}
      {[firstColumnData, secondColumnData].map((list, index) => (
        <Col key={index} xxl="6" className="box-col-12">
          <h5 className="f-w-700 mb-2">{AllAbout}</h5>
          {list.map((item) => (
            <div className="d-flex info-block" key={item.id}>
              <iframe className="me-3" width="200" height="100" src={item.videoLink} title="videos"></iframe>
              <div className="flex-grow-1">
                <Link to={Href}>{item.url}</Link>
                <h5>{item.title}</h5>
                <div className="star-ratings">
                  <ul className="search-info">
                    <li>{item.star}</li>
                    <li>{item.vote}</li>
                    <li>{item.news}</li>
                  </ul>
                </div>
              </div>
            </div>
          ))}
          {index === 0 && <PaginationCard pageClass="start" />}
        </Col>
      ))}
    </Row>
  );
};

export default VideoTabs;
